/**
 * `/app/projects` — the route. The page is `pages/client/projects/`.
 *
 * A route file is the address and the guard; the page is the screen. Keeping them
 * apart is what lets a page test mount the page over the recorded world without the
 * router's own tree (`test/clientPage.tsx`), and it is why every one of these is
 * four lines.
 */

import { createFileRoute } from '@tanstack/react-router'

import { ProjectsPage, ProjectsSearchSchema } from '../../pages/client/projects/ProjectsPage.js'
import { routeSearch } from '../../search/useSearchState.js'

export const Route = createFileRoute('/app/projects')({
  /**
   * `?show=active|all` — the page owns it, so it is declared here as well as read
   * through `useSearchState`. `/app`'s own `validateSearch` knows only `notice`,
   * and a route that did not name `show` would have it stripped out of the URL the
   * first time the seg wrote it — which is the back button quietly not working.
   *
   * `routeSearch` is the declaration without the refusal: `?show=nonsense` is the
   * active list, the same answer `useSearchState` gives the page below it.
   */
  validateSearch: routeSearch(ProjectsSearchSchema),
  component: ProjectsPage,
})
